import { CorePalette } from '@material/material-color-utilities'

export interface SchemeProperties {
  background: number
  error: number
  errorContainer: number
  inverseOnSurface: number
  inversePrimary: number
  inverseSurface: number
  onBackground: number
  onError: number
  onErrorContainer: number
  onPrimary: number
  onPrimaryContainer: number
  onPrimaryFixed: number
  onPrimaryFixedVariant: number
  onSecondary: number
  onSecondaryContainer: number
  onSecondaryFixed: number
  onSecondaryFixedVariant: number
  onSurface: number
  onSurfaceVariant: number
  onTertiary: number
  onTertiaryContainer: number
  onTertiaryFixed: number
  onTertiaryFixedVariant: number
  outline: number
  outlineVariant: number
  primary: number
  primaryContainer: number
  primaryFixed: number
  primaryFixedDim: number
  primarySurface: number
  scrim: number
  secondary: number
  secondaryContainer: number
  secondaryFixed: number
  secondaryFixedDim: number
  secondarySurface: number
  shadow: number
  surface: number
  surfaceBright: number
  surfaceContainer: number
  surfaceContainerHigh: number
  surfaceContainerHighest: number
  surfaceContainerLow: number
  surfaceContainerLowest: number
  surfaceDim: number
  surfaceTint: number
  surfaceVariant: number
  tertiary: number
  tertiaryContainer: number
  tertiaryFixed: number
  tertiaryFixedDim: number
  tertiarySurface: number
}

/**
 * Represents a Material color scheme, a mapping of color roles to colors.
 */
export class Scheme {
  /*get primary(): number {
    return this.props.primary
  }

  get onPrimary(): number {
    return this.props.onPrimary
  }

  get primaryContainer(): number {
    return this.props.primaryContainer
  }

  get onPrimaryContainer(): number {
    return this.props.onPrimaryContainer
  }

  get secondary(): number {
    return this.props.secondary
  }

  get onSecondary(): number {
    return this.props.onSecondary
  }

  get secondaryContainer(): number {
    return this.props.secondaryContainer
  }

  get onSecondaryContainer(): number {
    return this.props.onSecondaryContainer
  }

  get tertiary(): number {
    return this.props.tertiary
  }

  get onTertiary(): number {
    return this.props.onTertiary
  }

  get tertiaryContainer(): number {
    return this.props.tertiaryContainer
  }

  get onTertiaryContainer(): number {
    return this.props.onTertiaryContainer
  }

  get error(): number {
    return this.props.error
  }

  get onError(): number {
    return this.props.onError
  }

  get errorContainer(): number {
    return this.props.errorContainer
  }

  get onErrorContainer(): number {
    return this.props.onErrorContainer
  }

  get background(): number {
    return this.props.background
  }

  get onBackground(): number {
    return this.props.onBackground
  }

  get surface(): number {
    return this.props.surface
  }

  get onSurface(): number {
    return this.props.onSurface
  }

  get surfaceVariant(): number {
    return this.props.surfaceVariant
  }

  get onSurfaceVariant(): number {
    return this.props.onSurfaceVariant
  }

  get outline(): number {
    return this.props.outline
  }

  get outlineVariant(): number {
    return this.props.outlineVariant
  }

  get shadow(): number {
    return this.props.shadow
  }

  get scrim(): number {
    return this.props.scrim
  }

  get inverseSurface(): number {
    return this.props.inverseSurface
  }

  get inverseOnSurface(): number {
    return this.props.inverseOnSurface
  }

  get inversePrimary(): number {
    return this.props.inversePrimary
  }*/

  get background(): number {
    return this.props.background
  }
  get error(): number {
    return this.props.error
  }
  get errorContainer(): number {
    return this.props.errorContainer
  }
  get inverseOnSurface(): number {
    return this.props.inverseOnSurface
  }
  get inversePrimary(): number {
    return this.props.inversePrimary
  }
  get inverseSurface(): number {
    return this.props.inverseSurface
  }
  get onBackground(): number {
    return this.props.onBackground
  }
  get onError(): number {
    return this.props.onError
  }
  get onErrorContainer(): number {
    return this.props.onErrorContainer
  }
  get onPrimary(): number {
    return this.props.onPrimary
  }
  get onPrimaryContainer(): number {
    return this.props.onPrimaryContainer
  }
  get onPrimaryFixed(): number {
    return this.props.onPrimaryFixed
  }
  get onPrimaryFixedVariant(): number {
    return this.props.onPrimaryFixedVariant
  }
  get onSecondary(): number {
    return this.props.onSecondary
  }
  get onSecondaryContainer(): number {
    return this.props.onSecondaryContainer
  }
  get onSecondaryFixed(): number {
    return this.props.onSecondaryFixed
  }
  get onSecondaryFixedVariant(): number {
    return this.props.onSecondaryFixedVariant
  }
  get onSurface(): number {
    return this.props.onSurface
  }
  get onSurfaceVariant(): number {
    return this.props.onSurfaceVariant
  }
  get onTertiary(): number {
    return this.props.onTertiary
  }
  get onTertiaryContainer(): number {
    return this.props.onTertiaryContainer
  }
  get onTertiaryFixed(): number {
    return this.props.onTertiaryFixed
  }
  get onTertiaryFixedVariant(): number {
    return this.props.onTertiaryFixedVariant
  }
  get outline(): number {
    return this.props.outline
  }
  get outlineVariant(): number {
    return this.props.outlineVariant
  }
  get primary(): number {
    return this.props.primary
  }
  get primaryContainer(): number {
    return this.props.primaryContainer
  }
  get primaryFixed(): number {
    return this.props.primaryFixed
  }
  get primaryFixedDim(): number {
    return this.props.primaryFixedDim
  }
  get primarySurface(): number {
    return this.props.primarySurface
  }
  get scrim(): number {
    return this.props.scrim
  }
  get secondary(): number {
    return this.props.secondary
  }
  get secondaryContainer(): number {
    return this.props.secondaryContainer
  }
  get secondaryFixed(): number {
    return this.props.secondaryFixed
  }
  get secondaryFixedDim(): number {
    return this.props.secondaryFixedDim
  }
  get shadow(): number {
    return this.props.shadow
  }
  get surface(): number {
    return this.props.surface
  }
  get surfaceBright(): number {
    return this.props.surfaceBright
  }
  get surfaceContainer(): number {
    return this.props.surfaceContainer
  }
  get surfaceContainerHigh(): number {
    return this.props.surfaceContainerHigh
  }
  get surfaceContainerHighest(): number {
    return this.props.surfaceContainerHighest
  }
  get surfaceContainerLow(): number {
    return this.props.surfaceContainerLow
  }
  get surfaceContainerLowest(): number {
    return this.props.surfaceContainerLowest
  }
  get surfaceDim(): number {
    return this.props.surfaceDim
  }
  get surfaceTint(): number {
    return this.props.surfaceTint
  }
  get surfaceVariant(): number {
    return this.props.surfaceVariant
  }
  get tertiary(): number {
    return this.props.tertiary
  }
  get tertiaryContainer(): number {
    return this.props.tertiaryContainer
  }
  get tertiaryFixed(): number {
    return this.props.tertiaryFixed
  }
  get tertiaryFixedDim(): number {
    return this.props.tertiaryFixedDim
  }

  /**
   * @param argb ARGB representation of a color.
   * @return Light Material color scheme, based on the color's hue.
   */
  static light(argb: number): Scheme {
    return Scheme.lightFromCorePalette(CorePalette.of(argb))
  }

  /**
   * @param argb ARGB representation of a color.
   * @return Dark Material color scheme, based on the color's hue.
   */
  static dark(argb: number): Scheme {
    return Scheme.darkFromCorePalette(CorePalette.of(argb))
  }

  /**
   * @param argb ARGB representation of a color.
   * @return Light Material content color scheme, based on the color's hue.
   */
  static lightContent(argb: number): Scheme {
    return Scheme.lightFromCorePalette(CorePalette.contentOf(argb))
  }

  /**
   * @param argb ARGB representation of a color.
   * @return Dark Material content color scheme, based on the color's hue.
   */
  static darkContent(argb: number): Scheme {
    return Scheme.darkFromCorePalette(CorePalette.contentOf(argb))
  }

  /**
   * Light scheme from core palette
   */
  /*static lightFromCorePalette(core: CorePalette): Scheme {
    return new Scheme({
      primary: core.a1.tone(40),
      onPrimary: core.a1.tone(100),
      primaryContainer: core.a1.tone(90),
      onPrimaryContainer: core.a1.tone(10),
      secondary: core.a2.tone(40),
      onSecondary: core.a2.tone(100),
      secondaryContainer: core.a2.tone(90),
      onSecondaryContainer: core.a2.tone(10),
      tertiary: core.a3.tone(40),
      onTertiary: core.a3.tone(100),
      tertiaryContainer: core.a3.tone(90),
      onTertiaryContainer: core.a3.tone(10),
      error: core.error.tone(40),
      onError: core.error.tone(100),
      errorContainer: core.error.tone(90),
      onErrorContainer: core.error.tone(10),
      background: core.n1.tone(99),
      onBackground: core.n1.tone(10),
      surface: core.n1.tone(99),
      onSurface: core.n1.tone(10),
      surfaceVariant: core.n2.tone(90),
      onSurfaceVariant: core.n2.tone(30),
      outline: core.n2.tone(50),
      outlineVariant: core.n2.tone(80),
      shadow: core.n1.tone(0),
      scrim: core.n1.tone(0),
      inverseSurface: core.n1.tone(20),
      inverseOnSurface: core.n1.tone(95),
      inversePrimary: core.a1.tone(80)
    })
  }*/

  /**
   * Dark scheme from core palette
   */
  /*static darkFromCorePalette(core: CorePalette): Scheme {
    return new Scheme({
      primary: core.a1.tone(80),
      onPrimary: core.a1.tone(20),
      primaryContainer: core.a1.tone(30),
      onPrimaryContainer: core.a1.tone(90),
      secondary: core.a2.tone(80),
      onSecondary: core.a2.tone(20),
      secondaryContainer: core.a2.tone(30),
      onSecondaryContainer: core.a2.tone(90),
      tertiary: core.a3.tone(80),
      onTertiary: core.a3.tone(20),
      tertiaryContainer: core.a3.tone(30),
      onTertiaryContainer: core.a3.tone(90),
      error: core.error.tone(80),
      onError: core.error.tone(20),
      errorContainer: core.error.tone(30),
      onErrorContainer: core.error.tone(80),
      background: core.n1.tone(10),
      onBackground: core.n1.tone(90),
      surface: core.n1.tone(10),
      onSurface: core.n1.tone(90),
      surfaceVariant: core.n2.tone(30),
      onSurfaceVariant: core.n2.tone(80),
      outline: core.n2.tone(60),
      outlineVariant: core.n2.tone(30),
      shadow: core.n1.tone(0),
      scrim: core.n1.tone(0),
      inverseSurface: core.n1.tone(90),
      inverseOnSurface: core.n1.tone(20),
      inversePrimary: core.a1.tone(40)
    })
  }*/

  static lightFromCorePalette(core: CorePalette): Scheme {
    return new Scheme({
      background: core.n1.tone(99),
      error: core.error.tone(40),
      errorContainer: core.error.tone(90),
      inverseOnSurface: core.n1.tone(95),
      inversePrimary: core.a1.tone(80),
      inverseSurface: core.n1.tone(20),
      onBackground: core.n1.tone(10),
      onError: core.error.tone(100),
      onErrorContainer: core.error.tone(10),
      onPrimary: core.a1.tone(100),
      onPrimaryContainer: core.a1.tone(10),
      onPrimaryFixed: core.a1.tone(10),
      onPrimaryFixedVariant: core.a1.tone(30),
      onSecondary: core.a2.tone(100),
      onSecondaryContainer: core.a2.tone(10),
      onSecondaryFixed: core.a2.tone(10),
      onSecondaryFixedVariant: core.a2.tone(30),
      onSurface: core.n1.tone(10),
      onSurfaceVariant: core.n2.tone(30),
      onTertiary: core.a3.tone(100),
      onTertiaryContainer: core.a3.tone(10),
      onTertiaryFixed: core.a3.tone(10),
      onTertiaryFixedVariant: core.a3.tone(30),
      outline: core.n2.tone(50),
      outlineVariant: core.n2.tone(80),
      primary: core.a1.tone(40),
      primaryContainer: core.a1.tone(90),
      primaryFixed: core.a1.tone(90),
      primaryFixedDim: core.a1.tone(80),
      primarySurface: core.a1.tone(96),
      scrim: core.n1.tone(0),
      secondary: core.a2.tone(40),
      secondaryContainer: core.a2.tone(90),
      secondaryFixed: core.a2.tone(90),
      secondaryFixedDim: core.a2.tone(80),
      secondarySurface: core.a2.tone(96),
      shadow: core.n1.tone(0),
      surface: core.n1.tone(99),
      surfaceBright: core.n1.tone(98),
      surfaceContainer: core.n1.tone(94),
      surfaceContainerHigh: core.n1.tone(92),
      surfaceContainerHighest: core.n1.tone(90),
      surfaceContainerLow: core.n1.tone(96),
      surfaceContainerLowest: core.n1.tone(100),
      surfaceDim: core.n1.tone(87),
      surfaceTint: core.a1.tone(40),
      surfaceVariant: core.n2.tone(90),
      tertiary: core.a3.tone(40),
      tertiaryContainer: core.a3.tone(90),
      tertiaryFixed: core.a3.tone(90),
      tertiaryFixedDim: core.a3.tone(80),
      tertiarySurface: core.a3.tone(96),
    })
  }

  static darkFromCorePalette(core: CorePalette): Scheme {
    return new Scheme({
      background: core.n1.tone(10),
      error: core.error.tone(80),
      errorContainer: core.error.tone(30),
      inverseOnSurface: core.n1.tone(20),
      inversePrimary: core.a1.tone(40),
      inverseSurface: core.n1.tone(90),
      onBackground: core.n1.tone(90),
      onError: core.error.tone(20),
      //onErrorContainer: core.error.tone(90),
      onErrorContainer: core.error.tone(80),
      onPrimary: core.a1.tone(20),
      onPrimaryContainer: core.a1.tone(90),
      onPrimaryFixed: core.a1.tone(10),
      onPrimaryFixedVariant: core.a1.tone(30),
      onSecondary: core.a2.tone(20),
      onSecondaryContainer: core.a2.tone(90),
      onSecondaryFixed: core.a2.tone(10),
      onSecondaryFixedVariant: core.a2.tone(30),
      onSurface: core.n1.tone(90),
      onSurfaceVariant: core.n2.tone(80),
      onTertiary: core.a3.tone(20),
      onTertiaryContainer: core.a3.tone(90),
      onTertiaryFixed: core.a3.tone(10),
      onTertiaryFixedVariant: core.a3.tone(30),
      outline: core.n2.tone(60),
      outlineVariant: core.n2.tone(30),
      primary: core.a1.tone(80),
      primaryContainer: core.a1.tone(30),
      primaryFixed: core.a1.tone(90),
      primaryFixedDim: core.a1.tone(80),
      primarySurface: core.a1.tone(20),
      scrim: core.n1.tone(0),
      secondary: core.a2.tone(80),
      secondaryContainer: core.a2.tone(30),
      secondaryFixed: core.a2.tone(90),
      secondaryFixedDim: core.a2.tone(80),
      secondarySurface: core.a2.tone(20),
      shadow: core.n1.tone(0),
      surface: core.n1.tone(10),
      surfaceBright: core.n1.tone(24),
      surfaceContainer: core.n1.tone(12),
      surfaceContainerHigh: core.n1.tone(17),
      surfaceContainerHighest: core.n1.tone(22),
      surfaceContainerLow: core.n1.tone(10),
      surfaceContainerLowest: core.n1.tone(4),
      surfaceDim: core.n1.tone(6),
      surfaceTint: core.a1.tone(80),
      surfaceVariant: core.n2.tone(30),
      tertiary: core.a3.tone(80),
      tertiaryContainer: core.a3.tone(30),
      tertiaryFixed: core.a3.tone(90),
      tertiaryFixedDim: core.a3.tone(80),
      tertiarySurface: core.a3.tone(20),
    })
  }

  private constructor(private readonly props: SchemeProperties) {}

  toJSON() {
    return {
      ...this.props,
    }
  }
}
